<ng-progress [spinner]="false" role="status">
  <span class="visually-hidden">Loading...</span>
</ng-progress>

<div *ngIf="isLoadingAuth" class="global-loading">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<ng-container *ngIf="!isLoadingAuth">
  <div class="page" [class.no-scroll]="modalIsOpen">
    <ng-container *ngIf="!hasApiAuthError">
      <ng-container *ngIf="shouldDisplayLayout">
        <app-header></app-header>

        <app-navbar></app-navbar>
      </ng-container>

      <ng-container *ngIf="shouldDisplayBreadcrumb && isDesktop">
        <app-breadcrumb></app-breadcrumb>
      </ng-container>

      <div class="content" [class.no-breadcrumb]="!shouldDisplayBreadcrumb">
        <ng-container *ngIf="!hasUserAuthError">
          <router-outlet></router-outlet>
        </ng-container>

        <ng-container *ngIf="hasUserAuthError">
          <div class="error-content-container container">
            <ng-container *ngTemplateOutlet="errorPageTemplate"></ng-container>
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="shouldDisplayLayout">
        <app-footer></app-footer>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="hasApiAuthError">
      <div class="error-page-container">
        <ng-container *ngTemplateOutlet="errorPageTemplate"></ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>


<ng-template #errorPageTemplate>
  <h2 class="error-title">Ops!</h2>

  <span class="error-text">Ocorreu um erro ao tentar carregar esta página, clique no botão abaixo para tentar
    novamente.</span>

  <app-button [text]="'Recarregar Página'" (clickEvent)="refreshPage()"></app-button>
</ng-template>


<div class="hidden" data-bs-toggle="modal" data-bs-target="#session-expired-modal" #openSessionExpiredModal></div>


<div class="hidden" data-bs-toggle="modal" data-bs-target="#session-incomplete-modal" #openSessionIncompleteModal></div>

<div class="modal fade" id="session-expired-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-body">
        <ng-container *ngIf="allowSessionExpiredModal">
          <div class="session-expired-icon-container">
            <app-lucide-icon [iconName]="'triangle-alert'" [size]="80"></app-lucide-icon>
          </div>

          <span class="session-expired-text">Sua sessão expirou.</span>

          <span class="session-expired-text">Faça login novamente para iniciar um novo atendimento.</span>

          <div class="session-expired-button-container">
            <div class="session-expired-button">
              <app-button [text]="'OK'" [fullWidth]="true" data-bs-dismiss="modal"
                (clickEvent)="handleSessionExpiredModalClose()"></app-button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="session-incomplete-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-body">
        <ng-container *ngIf="allowSessionIncompleteModal">
          <div class="session-expired-icon-container">
            <app-lucide-icon [iconName]="'triangle-alert'">
            </app-lucide-icon>
          </div>

          <span class="session-expired-text">Acesso negado.</span>

          <span class="session-expired-text">Favor revisar as permissões de acesso ao Login GovBR.</span>
          <span class="session-expired-text">{{messageError}}</span>

          <span class="session-expired-text">ao clicar no ok você sera redirecionado ao login.</span>

          <div class="session-expired-button-container">
            <div class="session-expired-button">
              <app-button [text]="'OK'" [fullWidth]="true" data-bs-dismiss="modal"
                (clickEvent)="handleSessionIncompleteModalClose()"></app-button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="hidden" data-bs-toggle="modal" data-bs-target="#session-forbidden-modal" #openSessionForbiddenModal></div>
<div class="modal fade" id="session-forbidden-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-body">
        <ng-container *ngIf="allowSessionForbiddenModal">
          <div class="session-expired-icon-container">
            <app-lucide-icon [iconName]="'triangle-alert'">
            </app-lucide-icon>
          </div>

          <span class="session-expired-text">Ocorreu um erro.</span>

          <span class="session-expired-text">Faça login novamente para iniciar um novo atendimento.</span>

          <div class="session-expired-button-container">
            <div class="session-expired-button">
              <app-button [text]="'OK'" [fullWidth]="true" data-bs-dismiss="modal"
                (clickEvent)="handleSessionForbiddenModalClose()"></app-button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>